// extracted by mini-css-extract-plugin
export default {"banner":"styles_banner__mbwY7","content":"styles_content__CV-6b","actions":"styles_actions__MpnGi"};